<template>
  <div class="mx-auto flex w-full flex-col items-start justify-center gap-y-6">
    <h3 v-if="subtitle" class="w-full text-2xl font-bold text-s-900">
      {{ subtitle }}
    </h3>

    <DescriptionAndPackages
      v-if="descriptions || packages"
      :services-title="packages.title"
      :services-items="packages.services"
      :services-items-classes="packages.classes"
      :descriptions-title="descriptions.title"
      :descriptions-items="descriptions.texts"
    >
      <slot name="description" />
    </DescriptionAndPackages>

    <div v-if="subscribe" class="flex flex-col gap-y-4">
      <h4 class="text-left text-xl font-bold"> Subscribe to gain access </h4>
      <GroupButtons
        :initial-fields="subscribe.checkboxes"
        :file="subscribe.methodology"
        download-text="Methodology"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import type {
  TCDDescriptions,
  TCDPackages,
  TCDSubscribe,
} from '~/src/types/capacity-database'

/** components */
const DescriptionAndPackages = defineAsyncComponent(
  () => import('~/components/capacity-database/DescriptionAndPackages.vue'),
)
const GroupButtons = defineAsyncComponent(
  () => import('~/components/shared/services/GroupButtons.vue'),
)

withDefaults(
  defineProps<{
    subtitle?: string | null
    descriptions?: TCDDescriptions | null
    packages?: TCDPackages | null
    subscribe?: TCDSubscribe | null
  }>(),
  {
    subtitle: null,
    descriptions: null,
    packages: null,
    subscribe: null,
  },
)
</script>
